function AboutOne({ item }) {
    return (
        <div className='w-full px-4 flex flex-col gap-1 relative'>
            <img className='w-full h-auto' src={item.item.imageLink} alt={item.item.altText} />

            <div className="w-full flex flex-col gap-1 font-medium absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 px-6">
                <h1 className='text-[12px] leading-5 text-[#FFFFFF]'>{item.item.Heading}</h1>

                <p className='text-[8px] leading-4 text-[#B0B0B0]'>{item.item.Description}</p>
            </div>
        </div>
    );
}

export default AboutOne;
